import { FormControl, FormHelperText } from '@material-ui/core';
import React from 'react';
import { SwitchWithLabelProps, SwitchWithLabel } from '../SwitchWithLabel';

export type SwitchFieldProps = {
    disabled?: boolean;
    error?: boolean;
    fullWidth?: boolean;
    helperText?: React.ReactNode;
    label: SwitchWithLabelProps['label'];
    onChange?: SwitchWithLabelProps['onChange'];
    value?: SwitchWithLabelProps['value'];
};

export function SwitchField({
    disabled,
    error,
    fullWidth,
    helperText,
    label,
    onChange,
    value,
}: SwitchFieldProps): JSX.Element {
    return (
        <FormControl disabled={disabled} error={error} fullWidth={fullWidth}>
            <SwitchWithLabel label={label} value={value} onChange={onChange} />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
}
SwitchField.displayName = 'SwitchField';
